import { useState, useEffect } from "react";
import Header from "../../component/menu/Header";
import { constants } from "../../constant/constants";
import SideMenu from "../../component/menu/SideMenu";
import useUserStore from "../../stores/store";
import { ReportService } from "../../services/reports-services";
import CustomLoader from "../../component/menu/CustomLoader";
import CouponsReportComponent from "../../component/restaurants/reports/CouponsReportComponent";
import dayjs from "dayjs";

export default function CouponReport() {
    const { user, restaurantId, showNotification, networkCall, setNetworkCall } = useUserStore();
    const [couponReportList, setCouponReportList] = useState(null);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalItem, setTotalItem] = useState(0);
    const [couponsFilter, setCouponsFilter] = useState({
        restaurantId: restaurantId,
        searchKey: "",
        fromDateTime: "",
        toDateTime: ""
    });
    const [isFilterClear, setIsFilterClear] = useState(false);

    function formatCouponList(data = []) {
        if (data.length === 0) return [];

        return data.map((el, idx) => ({
            id: el.id,
            title: el.title,
            couponCode: el.code,
            launchDate: dayjs(el.validFrom).format("YYYY-MM-DD"),
            expiryDate: dayjs(el.validUntil).format("YYYY-MM-DD"),
            usedCount: el.usedCount,
            subtotal: el.subTotal,
            couponDiscount: el.couponDiscount,
            paymentReceived: el.paymentReceived,
            valueShare: el.valueShare
        }))
    }

    // fetch from reports list api
    async function fetchCouponReportList(filter) {
        setNetworkCall(true);
        try {
            const couponList = await ReportService.getCouponReportList(filter, user.token.token);
            setCouponReportList(formatCouponList(couponList.data));
            setPage(couponList.page);
            setPerPage(couponList.perPage);
            setTotalItem(couponList.total);
            setNetworkCall(false);
        } catch (err) {
            showNotification("Something went wrong in serverside. Try again later.");
            setNetworkCall(false);
            return;
        }
    }

    // initial loading
    useEffect(() => {

        fetchCouponReportList(couponsFilter);
    }, [restaurantId]);

    // while filter is clear
    useEffect(() => {
        async function fetchData() {
            if (isFilterClear) {
                await fetchCouponReportList(couponsFilter);
                setIsFilterClear(false);
            }
        }

        fetchData();
    }, [isFilterClear]);

    function onHandleFilterData() {
        if (page !== 1 || perPage !== 10) {
            setPage(1);
            setPerPage(10);
        }
        const tempFilter = { ...couponsFilter, page: 1, perPage: 10 };
        fetchCouponReportList(tempFilter);
    }

    function onHandlePageChange(page, pageSize) {
        const filter = { ...couponsFilter, page: page, perPage: pageSize };
        fetchCouponReportList(filter);
        setPage(page);
        setPerPage(pageSize);
    }

    function onHandlePageSizeChange(current, size) {
        const filter = { ...couponsFilter, page: page, perPage: size };
        fetchCouponReportList(filter);
        setPerPage(size);
    }

    function onHandleDownloadReport() {
        setNetworkCall(true);
        ReportService.getDownloadCouponsReport(couponsFilter, user.token.token).then((res) => {
            if (res.data) {
                setNetworkCall(false);
                ReportService.downloadPDF(res.data, "coupons-report.pdf");
                showNotification('Coupons report downloaded successfully!', false);
            } else {
                setNetworkCall(false);
                showNotification("Failed to download the report");
                return;
            }
        });
    }

    return (
        <section>
            <div className="flex flex-col">
                <CustomLoader />
                <Header title={""} menu={constants.MENU.SALES_REPORT} currentMenuKey={"T_6_S_6_L_6"} />
                <div className="flex flex-row bg-prewhite px-[12%]">
                    <SideMenu title={`Coupon Report`} menu={constants.MENU.SALES_REPORT} />
                </div>
                <div className=" mt-[80px] ml-[80px] px-[50px]">
                    <h1 className="pt-[50px] pb-[20px] font-bold text-black text-[24px] leading-[24px] cursor-default">
                        {constants.MENU.REPORTS[6]}
                    </h1>

                    <CouponsReportComponent
                        reportData={couponReportList}
                        setCouponsFilter={setCouponsFilter}
                        handleFilterApply={onHandleFilterData}
                        page={page}
                        perPage={perPage}
                        setPerPage={setPerPage}
                        total={totalItem}
                        handlePageChange={onHandlePageChange}
                        handlePageSizeChange={onHandlePageSizeChange}
                        setIsFilterClear={setIsFilterClear}
                        handleDownload={onHandleDownloadReport}
                        loading={networkCall}
                    />
                </div>
            </div>
        </section>
    );
}
